export default __webpack_public_path__ + "static/media/stake-more-l3p.6fad0ce2.svg";